import { mount } from "@vue/test-utils";
import ProgressBar from "@/components/core/ProgressBar";

jest.mock("@/components/core/ProgressBar", () => ({
  ...jest.requireActual("@/components/core/ProgressBar"),
  methods: {
    watch: jest.fn()
  }
}));

describe("ProgressBar test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(ProgressBar);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component ProgressBar", () => {
    expect(wrapper).toBeDefined();
  });
});
